
import { apiGet } from "@/lib/api-client";
import type { TransactionsApiResponse } from "@/types/api/transactions";

export interface GetTransactionsParams extends Record<string, string | number | boolean | undefined> {
  page?: number;
  pageSize?: number;
  search?: string;
  transactionType?: string;
  status?: string;
  customerId?: string;
  dateFrom?: string;
  dateTo?: string;
  amountMin?: number;
  amountMax?: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export async function getTransactions(params?: GetTransactionsParams, signal?: AbortSignal): Promise<TransactionsApiResponse> {
  return apiGet<TransactionsApiResponse>("/api/v1/transactions", params, signal);
}
